import React, { useEffect } from 'react'
import { MotifToast } from '@ey-xd/motif-react'
import './Toast.scss'

const Toast = ({ visible, setVisible, children, variant }: any) => {
  
  useEffect(() => {
    if (visible) {
      const timer = setTimeout(() => {
        setVisible(false);
      }, 2000);

      return () => clearTimeout(timer);
    }
  }, [visible]);

  return (
    <div className='toastWrapper'>
        {visible && (
            <MotifToast
                actionName=""
                onClose={() => {setVisible(false)}}
                position="top"
                variant={variant}
            >
                {children}
            </MotifToast>
        )}
    </div>
  )
}

export default Toast
